import React from "react";
import { Switch, Route } from "react-router-dom";
import MainPage from "./pages/MainPage";
import { CssBaseline } from "@mui/material";
import { LinkValues } from "./values/strings";
import TermsPage from "./pages/TermsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import UnavailablePage from "./pages/UnavailablePage";
import {
  IpgCoreviewPage,
  TransactionReceiptCoreviewPage,
} from "./pages/CoreviewPage";
import LiveSupportPage from "./pages/LiveSupportPage";
import LicencesPage from "./pages/LicencesPage";
import AboutPage from "./pages/AboutPage";
import WalletPage from "./pages/WalletPage";

function App() {
  return (
    <>
      <CssBaseline />
      <Switch>
        <Route path={LinkValues.routes.base(true)} exact component={MainPage} />
        <Route
          path={LinkValues.routes.market.self()}
          exact
          component={UnavailablePage}
        />
        <Route
          path={LinkValues.routes.earn.self()}
          exact
          component={UnavailablePage}
        />
        <Route
          path={LinkValues.routes.wallet.self()}
          exact
          component={UnavailablePage}
        />
        <Route
          path={LinkValues.routes.trade.self()}
          exact
          component={UnavailablePage}
        />
        <Route
          path={LinkValues.routes.auth.login()}
          exact
          component={UnavailablePage}
        />
        <Route
          path={LinkValues.routes.auth.register()}
          exact
          component={UnavailablePage}
        />
        <Route
          path={LinkValues.routes.coreview.ipg.payping()}
          exact
          component={IpgCoreviewPage}
        />
        <Route
          path={LinkValues.routes.coreview.ipg.zarinpal()}
          exact
          component={IpgCoreviewPage}
        />
        <Route
          path={LinkValues.routes.coreview.ipg.novinopay()}
          exact
          component={IpgCoreviewPage}
        />
        <Route
          path={LinkValues.routes.liveSupport.self()}
          exact
          component={LiveSupportPage}
        />
        <Route
          path={LinkValues.routes.terms.self()}
          exact
          component={TermsPage}
        />
        <Route
          path={LinkValues.routes.privacy.self()}
          exact
          component={PrivacyPolicyPage}
        />
        <Route
          path={LinkValues.routes.licences.self()}
          exact
          component={LicencesPage}
        />
        <Route
          path={LinkValues.routes.coreview.transaction.receipt()}
          exact
          component={TransactionReceiptCoreviewPage}
        />
        <Route
          path={LinkValues.routes.about.self()}
          exact
          component={AboutPage}
        />
        <Route
          path={LinkValues.routes.wallet.deposit.external()}
          exact
          component={WalletPage}
        />
        {/* <Route path="*" component={PageError404} /> */}
      </Switch>
    </>
  );
}

export default App;
